module.exports = __webpack_public_path__ + "img/img_bg.720b44ea.png";